import { render, staticRenderFns } from "./GoalSettingForm.vue?vue&type=template&id=11fc10bb&scoped=true&lang=pug&"
import script from "./GoalSettingForm.vue?vue&type=script&lang=ts&"
export * from "./GoalSettingForm.vue?vue&type=script&lang=ts&"
import style0 from "./GoalSettingForm.vue?vue&type=style&index=0&id=11fc10bb&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11fc10bb",
  null
  
)

export default component.exports